// Game progression states
export const GAME_STATES = {
  INITIAL: 'INITIAL',
  MET_TEACHER1: 'MET_TEACHER1',
  MET_TEACHER2: 'MET_TEACHER2',
  GOT_BOOK: 'GOT_BOOK',
  MET_CHILD1: 'MET_CHILD1',
  MET_FATHER: 'MET_FATHER',
  DREAM_START: 'DREAM_START',
  DREAM_POSTER: 'DREAM_POSTER',
  DREAM_NURSE: 'DREAM_NURSE',
  DREAM_DOCTOR: 'DREAM_DOCTOR',
  DREAM_END: 'DREAM_END',
  GAME_END: 'GAME_END'
};

// NPC IDs
export const NPC_IDS = {
  TEACHER1: 2562,
  TEACHER2: 2978,
  CHILD1: 3041,
  CHILD2: 3068,
  CHILD3: 2652,
  FATHER: 2469,
  MOTHER: 2052,
  DOCTOR: 1780,
  NURSE: 2092,
  OLD_MAN: 1767
};

// Dialogue sequences for each NPC
export const NPC_DIALOGUES = {
  [NPC_IDS.TEACHER1]: {
    initial: [
      { speaker: "Class Teacher", text: "Welcome! I'm glad you're here. We have a new student joining our school today - Aviani, who is Deaf and Hard of Hearing (DHH). You will be meeting Aviani today." },
      { speaker: "Class Teacher", text: "Let me tell you about DHH individuals and their experiences. Did you know that DHH people face unique challenges in communication and daily life?" },
      { 
        speaker: "Class Teacher", 
        text: "Question: What is the primary challenge faced by DHH individuals in a hearing world?\n1. Physical mobility\n2. Communication barriers\n3. Visual perception\n4. None of the above",
        isQuestion: true,
        correctAnswer: 2
      },
      { speaker: "Class Teacher", text: "Communication barriers are the primary challenge. DHH individuals often face difficulties in understanding spoken language and may feel isolated in social situations." },
      { speaker: "Class Teacher", text: "Please see the Language Teacher after this conversation to learn more about how we can communicate with DHH individuals in our school." },
      { speaker: "Class Teacher", text: "Language Teacher is waiting for you near the Library." }
    ]
  },
  [NPC_IDS.TEACHER2]: {
    beforeBook: [
      { speaker: "Language Teacher", text: "Hello! Today, I'm here to teach you about AUSLAN - Australian Sign Language." },
      { speaker: "Language Teacher", text: "AUSLAN is the primary language used by the Deaf community in Australia. It's a visual language that uses hand shapes, facial expressions, and body movements." },
      { speaker: "Language Teacher", text: "Here, take this AUSLAN book. It will help you learn basic signs." },
      { speaker: "System", text: "You received an AUSLAN book!" },
      {
        speaker: "Language Teacher",
        text: "Question: What does AUSLAN stand for?\n1. Australian Sign Language\n2. Australian Speaking Language\n3. Australian Silent Language\n4. Australian Signing Language",
        isQuestion: true,
        correctAnswer: 1
      },
      { speaker: "Language Teacher", text: "AUSLAN - Australian Sign Language.\nNow that you have the book, please meet Aviani." },
      { speaker: "Language Teacher", text: "Aviani is waiting to meet you! She is near the school playground." }
    ]
  },
  [NPC_IDS.CHILD1]: {
    initial: [
      { speaker: "Aviani", text: "Hello! I'm Aviani. I'm happy to meet you!" },
      { speaker: "Jayden", text: "Hello! I'm Jayden. I'm happy to meet you!" },
      { speaker: "Aviani", text: "I got to know that Language Teacher gave you the AUSLAN book. That's great! I use sign language to communicate." },
      { speaker: "Jayden", text: "Yeah, I will study about the sign language and will try to communicate with you in sign language." },
      { speaker: "Aviani", text: "I'm looking forward to learning and playing with everyone at school." },
      { speaker: "Jayden", text: "I think you will be a great friend." }
    ]
  },
  [NPC_IDS.FATHER]: {
    initial: [
      { speaker: "Father", text: "It's getting late, time to go to sleep. Hope you've had a great first day at school!" },
      { speaker: "Jayden", text: "It was a great day! I met Aviani and we played together. I also learned about DHH individuals and AUSLAN. I'm looking forward to tomorrow!" },
      { speaker: "Father", text: "I'm proud of you for learning about DHH individuals and AUSLAN. Rest well, and we'll continue learning tomorrow." }
    ]
  },
  [NPC_IDS.OLD_MAN]: {
    initial: [
      { speaker: "Old Man", text: "Hello young one! I see you're learning about DHH individuals and sign language." },
      { speaker: "Old Man", text: "Did you know that learning sign language can be fun and engaging?" },
      { speaker: "Old Man", text: "Visit www.signmates.me to learn more about DHH individuals and learn sign languages in a fun way!" },
      { speaker: "Old Man", text: "The website has interactive games, stories, and resources to help you understand and communicate with the DHH community." },
      { speaker: "Old Man", text: "I am giving you the Knowledge Badge as a reward for your learning." }
    ]
  }
};

// Dream-specific dialogues
export const DREAM_DIALOGUES = {
  [NPC_IDS.FATHER]: {
    initial: [
      { speaker: "Jayden", text: "How are you, Dad?" },
      { speaker: "Father", text: "..." },
      { speaker: "Jayden", text: "What are you saying?" },
      { speaker: "Father", text: "..." },
      { speaker: "Jayden", text: "I am not able to hear you." },
      { speaker: "Father", text: "..." },
      { speaker: "Jayden", text: "I am very scared." },
      { speaker: "Father", text: "..." },
      { speaker: "System", text: "Your Dad gives you a poster and asks you to meet the nurse." }
    ]
  },
  [NPC_IDS.MOTHER]: {
    initial: [
      { speaker: "Jayden", text: "How are you, Mum?" },
      { speaker: "Mother", text: "..." },
      { speaker: "Jayden", text: "What are you saying?" },
      { speaker: "Mother", text: "..." },
      { speaker: "Jayden", text: "I am not able to hear you." },
      { speaker: "Mother", text: "..." },
      { speaker: "Jayden", text: "I am very scared." },
      { speaker: "Mother", text: "..." },
      { speaker: "System", text: "Your Mum gives you a poster and asks you to meet the nurse." }
    ]
  },
  [NPC_IDS.NURSE]: {
    initial: [
      { speaker: "Nurse", text: "(Displays in a Note): We understand. It's hard not being heard." },
      { speaker: "Nurse", text: "(Displays in a Note): But with support, tools, and empathy, we can build bridges." },
      { speaker: "System", text: "You received a hearing aid!" },
      { speaker: "Nurse", text: "Please visit the doctor, he is waiting for you. He is near the next hospital building." }
    ]
  },
  [NPC_IDS.DOCTOR]: {
    initial: [
      { speaker: "Doctor", text: "Welcome. Hope you're feeling better.\nLet me share some important information about DHH individuals." },
      { speaker: "Doctor", text: "Did you know that approximately 1 in 6 Australians are affected by hearing loss?" },
      { speaker: "Doctor", text: "This is a common issue among DHH individuals. They often face difficulties in understanding spoken language and may feel isolated in social situations." },
      { speaker: "Doctor", text: "Now, you know how it feels to be DHH. You can now empathise with them.\nYou can now understand their feelings and emotions." },
    ]
  }
};

// Dream poster content
export const DREAM_POSTER = {
  title: "Understanding DHH Community",
  content: [
    "Some are born into silence. Others lose sound along the way. But all share one thing: resilience.Communication takes patience, courage, and kindness - from everyone.\n",
    "Your journey begins now. Head to the hospital. The nurse will guide you."
  ]
};

// Dream reflection
export const DREAM_REFLECTION = [
  "I can't just be curious. I have to learn to respect and understand.",
  "Tomorrow, I want to try to say hello to Aviani in sign language."
];

// Default responses for other NPCs based on game state
export const getDefaultDialogue = (npcId, gameState, hasKnowledgeBadge = false) => {
  // Return old man's dialogue if interacting with him
  if (npcId === NPC_IDS.OLD_MAN) {
    return NPC_DIALOGUES[NPC_IDS.OLD_MAN].initial;
  }

  // Special case for after poster but before nurse
  if (gameState === GAME_STATES.DREAM_POSTER && npcId !== NPC_IDS.NURSE && npcId !== NPC_IDS.OLD_MAN) {
    if (!hasKnowledgeBadge) {
      return [{ speaker: "System", text: "(A Note Appears): For a suprise, meet the old man near the pier for a side quest!\nMeet the Nurse near the hospital to continue the game." }];
    } else {
      return [{ speaker: "System", text: "(A Note Appears): Meet the Nurse near the hospital." }];
    }
  }

  if (gameState === GAME_STATES.INITIAL) {
    return [{ speaker: "System", text: "Please meet your Class Teacher. They're waiting to start the school day. The school is behind your home." }];
  }
  if (gameState === GAME_STATES.MET_TEACHER1) {
    return [{ speaker: "System", text: "Language Teacher has some important information he wants to share with you. Please visit him to continue your learning. He is near the Library which is to the left of the school." }];
  }
  if (gameState === GAME_STATES.MET_TEACHER2) {
    return [{ speaker: "System", text: "Aviani is waiting to meet you. She's excited to make new friends! She is near the school playground. Catch up with her there." }];
  }
  if (gameState === GAME_STATES.MET_CHILD1) {
    return [{ speaker: "System", text: "It's getting late. Your father is waiting for you near your home. Go home and see him." }];
  }
  if (gameState === GAME_STATES.DREAM_START) {
    return [{ speaker: "System", text: "You are in a dream, you are not able to hear anything. Speak with your father or mother first." }];
  }
  return [{ speaker: "System", text: "..." }];
};

// Check if NPC is interactable based on game state
export const isNPCInteractable = (npcId, gameState) => {
  // Always allow interaction with the old man
  if (npcId === NPC_IDS.OLD_MAN) {
    return true;
  }

  switch (gameState) {
    case GAME_STATES.INITIAL:
      return npcId === NPC_IDS.TEACHER1;
    case GAME_STATES.MET_TEACHER1:
      return npcId === NPC_IDS.TEACHER2;
    case GAME_STATES.MET_TEACHER2:
      return npcId === NPC_IDS.CHILD1;
    case GAME_STATES.MET_CHILD1:
      return npcId === NPC_IDS.FATHER;
    case GAME_STATES.MET_FATHER:
      return true; // Allow interaction with all NPCs in dream
    case GAME_STATES.DREAM_START:
      return npcId === NPC_IDS.FATHER || npcId === NPC_IDS.MOTHER;
    case GAME_STATES.DREAM_POSTER:
      return npcId === NPC_IDS.NURSE;
    case GAME_STATES.DREAM_NURSE:
      return npcId === NPC_IDS.DOCTOR;
    case GAME_STATES.DREAM_DOCTOR:
      return false; // No more interactions after doctor
    default:
      return false;
  }
};

// Get next game state after NPC interaction
export const getNextGameState = (npcId, currentState) => {
  switch (currentState) {
    case GAME_STATES.INITIAL:
      return npcId === NPC_IDS.TEACHER1 ? GAME_STATES.MET_TEACHER1 : currentState;
    case GAME_STATES.MET_TEACHER1:
      return npcId === NPC_IDS.TEACHER2 ? GAME_STATES.MET_TEACHER2 : currentState;
    case GAME_STATES.MET_TEACHER2:
      return npcId === NPC_IDS.CHILD1 ? GAME_STATES.MET_CHILD1 : currentState;
    case GAME_STATES.MET_CHILD1:
      // return npcId === NPC_IDS.FATHER ? GAME_STATES.MET_FATHER : currentState;
      return npcId === NPC_IDS.FATHER ? GAME_STATES.DREAM_START : currentState;
    // case GAME_STATES.MET_FATHER:
      // return GAME_STATES.DREAM_START;
    //   // Check if this is the father's final dialogue
    //   if (npcId === NPC_IDS.FATHER) {
    //     const fatherDialogue = NPC_DIALOGUES[NPC_IDS.FATHER].initial;
    //     const isLastDialogue = fatherDialogue && 
    //       fatherDialogue[fatherDialogue.length - 1]?.text === 
    //       "I'm proud of you for learning about DHH individuals and AUSLAN. Rest well, and we'll continue learning tomorrow.";
        
    //     if (isLastDialogue) {
    //       return GAME_STATES.DREAM_START;
    //     }
    //   }
    //   return currentState;
    case GAME_STATES.DREAM_START:
      if (npcId === NPC_IDS.FATHER || npcId === NPC_IDS.MOTHER) {
        return GAME_STATES.DREAM_POSTER;
      }
      return currentState;
    case GAME_STATES.DREAM_POSTER:
      return npcId === NPC_IDS.NURSE ? GAME_STATES.DREAM_NURSE : currentState;
    case GAME_STATES.DREAM_NURSE:
      return npcId === NPC_IDS.DOCTOR ? GAME_STATES.DREAM_DOCTOR : currentState;
    case GAME_STATES.DREAM_DOCTOR:
      return GAME_STATES.DREAM_END;
    case GAME_STATES.DREAM_END:
      return GAME_STATES.GAME_END;
    default:
      return currentState;
  }
}; 